/***********************************************************************************

ATENÇÃO

OS DADOS DESTA PÁGINA ESTÃO NO ARTIGO 179 

https://adm-portal.itajai.sc.gov.br/portaladm-pmitajai/artigo/detalhe/cod_artigo/179

EM HTML

CRIEI UM TXT: texto-original.txt

NELE TEM O TEXTO HTML PARA SUBSTITUIR CASO ALGO DÊ ERRADO

***********************************************************************************/

import { useEffect, useState } from "react";
import { api, urls } from "../../services/api";
import { TitlePage } from "../../components/ui/TitlePage";
import { IArticle } from "../../types/article";
import DOMPurify from 'dompurify';

export function ContactScreen() {

	const [article, setArticle] = useState<IArticle>(
		{
			content: '',
			published: '',
			title: 'Carregando...'
		}
	)

	const getArticleById = async (id: number) => {

		try {

			const response = await api.get(urls.Article + id)
			setArticle(response.data)

		} catch (error) {
			// console.log('Contact getArticleById - Erro: ', error)
		}

	}

	useEffect(() => {

		getArticleById(179)

	}, [])

	return (
		<div className="flex flex-col w-full min-h-screen bg-white dark:bg-surface-dark transition-colors items-center justify-start font-roboto">
			<TitlePage title={'Lista de telefones da Prefeitura de Itajaí'} />

			{article.content ? (
				<div
					className="contact-container"
					dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(article.content) }}
				/>
			) : (
				<div className="flex flex-wrap w-11/12 lg:w-3/5 justify-center pb-16 lg:pb-16 text-gray-500 dark:text-gray-400 mt-8">Sem texto</div>
			)}
		</div>
	);
}